
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Mission from './components/Mission';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Mission />
      <About />
      <Contact />
    </div>
  );
}
